import axios from "axios";

let endpoints = {
  emailAgent: "/agent/sendrecover",
  emailProfessional: "/professional/sendrecover",

  professional: "/professional",

  agent: "/agent",

  user: "/user",
  userAgent: "/user/agent",

  exam: "/exam",
  examAgent: "/exam/agent",
  examUser: "/exam/user",
  examProfessional: "/exam/professional",
};

let newFilter;

function getFilters(filter) {
  var filterURL;
  if (Array.isArray(filter)) {
    filterURL = "?";
    for (let i = 0; i < filter.length; i++) {
      filterURL += filter[i]["header"] + "=" + filter[i]["value"];
      if (i !== filter.length - 1) {
        filterURL += "&";
      }
    }
    return filterURL;
  } else {
    filter = '';
    return filter;
  }
}

var token = localStorage.getItem("user_token");

export default class Methods {
  //authenticate
  ProfessionalLogin(entity, par) {
    return axios.post(entity + endpoints.professional, par, {
      headers: { "x-access-token": token },
    });
  }
  AgentLogin(entity, par) {
    return axios.post(entity + endpoints.agent, par, {
      headers: { "x-access-token": token },
    });
  }
  //

  //Password
  editProfessionalPassword(entity, par, id) {
    return axios.patch(entity + endpoints.professional + "/" + id, par, {
      headers: { "x-access-token": token },
    });
  }
  editAgentPassword(entity, par, id) {
    return axios.patch(entity + endpoints.agent + "/" + id, par, {
      headers: { "x-access-token": token },
    });
  }
  //

  //Email
  createProfessionalEmail(entity, par) {
    return axios.post(entity + endpoints.emailProfessional, par, {
      headers: { "x-access-token": token },
    });
  }
  createAgentEmail(entity, par) {
    return axios.post(entity + endpoints.emailAgent, par, {
      headers: { "x-access-token": token },
    });
  }
  //

  //Self-reference
  create(entity, par) {
    return axios.post(entity + "/", par, { headers: { "x-access-token": token }}, {withCredentials:true});
  }
  /*
  get(entity, id) {
    return axios.get(entity + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  */
  //

  //Professional
  editProfessional(entity, par, id) {
    return axios.patch(entity + endpoints.professional + "/" + id, par, {
      headers: { "x-access-token": token },
    });
  }
  deleteProfessional(entity, id) {
    return axios.delete(entity + endpoints.professional + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  getAllProfessionals(entity, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.professional + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getProfessional(entity, id) {
    return axios.get(entity + endpoints.professional + "/" + id, {
      headers: { "x-access-token": token },
    });
  }

  //
  //Agent
  editAgents(entity, par, id) {
    return axios.patch(entity + endpoints.agent + "/" + id, par, {
      headers: { "x-access-token": token },
    });
  }
  deleteAgents(entity, id) {
    return axios.delete(entity + endpoints.agent + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  getAllAgents(entity, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.agent + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getAgent(entity, id) {
    return axios.get(entity + endpoints.agent + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  //

  //User
  createUser(entity, par) {
    return axios.post(entity + endpoints.user , par, {
      headers: { "x-access-token": token },
    });
  }
  editUser(entity, par, id, op) {
    return axios.patch(entity + endpoints.user + "/" + id, par, {
      headers: { "x-access-token": token, "op": op },
    });
  }
  getAllAgentUsers(entity, id, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.userAgent + "/" + id + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getUser(entity, id) {
    return axios.get(entity + endpoints.user + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  getAllUsers(entity, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.user + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  //

  //Exam
  createExam(entity, par) {
    return axios.post(entity + endpoints.exam, par, {
      headers: { "x-access-token": token },
    });
  }
  editExam(entity, par, id, op) {
    return axios.patch(entity + endpoints.exam + "/" + id, par, {
      headers: { "x-access-token": token, "op": op },
    });
  }
  getExam(entity, id) {
    return axios.get(entity + endpoints.exam + "/" + id, {
      headers: { "x-access-token": token },
    });
  }
  getAllUserExams(entity, id, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.examUser + "/" + id + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getAllExams(entity, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.exam + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getAllProfessionalExams(entity, id, filter) {
    newFilter = getFilters(filter);
    return axios.get(
      entity + endpoints.examProfessional + "/" + id + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  getAllAgentExams(entity, id, filter) {
    newFilter = getFilters(filter);
    return axios.get(entity + endpoints.examAgent + "/" + id + newFilter, {
      headers: { "x-access-token": token },
    });
  }
  //
}
